import {useTranslation} from "react-i18next";
import {dibAppApi} from "../../dibAppApi/dibAppApi";
import classes from "./SupplierInfo.module.css";

export const SupplierInfo = ({
    resourceId,
    segmentId,
}: {
    resourceId: string;
    segmentId: string | undefined;
}) => {
    const {data: documentData} = dibAppApi.endpoints.getDocument.useQuery({
        resourceId,
        segmentId,
    });
    const {t} = useTranslation();

    const supplier = documentData?.supplier;

    if (!supplier || supplier === "DIBkunnskap") {
        return null;
    }

    return (
        <div className={classes.infoSection}>
            <h2 className={classes.sectionHeader}>
                {t("Word.Info", {defaultValue: "Info"})}
            </h2>
            <span className={classes.supplierName}>{supplier}</span>
        </div>
    );
};
